module.exports = __webpack_public_path__ + "CreativeDirection32.jpg?a1abbb26b68649ef19fb4c190e22ea21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection32.jpg
// module id = 45
// module chunks = 0